import cloneDeep from 'lodash/cloneDeep';

import fseTheme from '../../themes/fse/theme';

const gijpTheme = cloneDeep(fseTheme);
gijpTheme.name = 'fregijp';
gijpTheme.logo = 'GIJP_LARGE';
gijpTheme.logoMobile = 'GIJP_MOBILE';
gijpTheme.footer.logoFooter = 'GIJP_FOOTER';
gijpTheme.jobDetail.automaticTranslation = true;
gijpTheme.hasShareSection = false;

gijpTheme.header.showCountrySwitch = false;

export { gijpTheme };
